import { AssessmentSection, AssessmentSectionQuestion } from 'types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import RadioField from 'components/common/FormFields/RadioField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

function _generateInputType(sectionQuestion: AssessmentSectionQuestion) {
  const answerType = sectionQuestion.assessmentQuestion.answerType;
  const questionId = sectionQuestion.assessmentQuestion.id;
  switch (answerType.format) {
    case 'RADIO':
      return (
        <RadioField name={questionId.toString()} label={questionId.toString()}>
          {answerType.options.map((option) => (
            <FormControlLabel
              name={questionId.toString()}
              key={option.id}
              value={option.id.toString()}
              control={<Radio />}
              label={option.text}
              style={{ marginRight: '40px' }}
            />
          ))}
        </RadioField>
      );
    default:
      return <p>{answerType.format} not supported right now</p>;
  }
}

const QuestionSection = (props: {
  section: AssessmentSection;
  isSubmitting: any;
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={8}>
        {props.section.assessmentSectionQuestions.map((question) => (
          <div
            key={question.assessmentQuestion.id}
            className={`${classes.formSection}${props.isSubmitting ? ` ${classes.loading}` : ''}`}
            style={{ flexGrow: 1 }}
          >
            <FormControl component="fieldset">
              <Typography variant="h4" style={{ marginBottom: '20px' }}>
                {question.assessmentQuestion.text}
              </Typography>
              {question.assessmentQuestion.instructions && (
                <Typography variant="h4" style={{ marginBottom: '20px' }}>
                  {question.assessmentQuestion.instructions}
                </Typography>
              )}
              {_generateInputType(question)}
            </FormControl>
          </div>
        ))}
      </Grid>
      <Grid item xs={4}>
        <div className={classes.formSection}>
          {props.section.thumbnail && (
            <Box
              component="img"
              src={props.section.thumbnail}
              style={{ width: '100%' }}
              className={classes.thumbnail}
            />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default QuestionSection;

const useStyles = makeStyles((theme: Theme) => {
  return {
    row: {
      display: 'flex',
      flexFlow: 'row wrap',
    },
    sectionHeader: {
      color: theme.palette.primary.main,
    },
    btnFilled: {
      borderRadius: '100px',
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(4),
      lineHeight: '1rem',
    },
    formSection: {
      marginTop: theme.spacing(4),

      '& .MuiButton-outlinedPrimary': {
        float: 'right',
        marginBottom: theme.spacing(4),
      },
    },
    footerGroup: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& .MuiButton-root': {
        marginLeft: theme.spacing(2),
      },
    },
    loading: {
      opacity: 0.4,
    },
    centered: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginRight: '-50%',
    },
    thumbnail: {
      border: `1px solid ${theme.palette.black.main}`,
      padding: theme.spacing(1),
    },
  };
});
